// @ts-nocheck
import { useState, useEffect } from 'react';
import './App.css';
import MagicSpiritGame from './magic-spirit';
import { SimulationApp } from './simulation-ui/SimulationApp';
import { loadCardsFromCSV } from './utils/cardManager';
import { AuthProvider } from './lib/useAuth';

type AppMode = 'menu' | 'card-game' | 'simulation';

function App() {
  const [mode, setMode] = useState<AppMode>('menu');
  const [allCards, setAllCards] = useState([]);

  useEffect(() => {
    loadCardsFromCSV().then(setAllCards);
  }, []);

  if (mode === 'menu') {
    return (
      <div style={styles.menu}>
        <h1 style={styles.menuTitle}>Magic Spirit</h1>
        <p style={styles.menuSubtitle}>Choose Game Mode</p>
        <div style={styles.menuButtons}>
          <button onClick={() => setMode('card-game')} style={styles.menuButton}>
            🎴 カードゲーム
          </button>
          <button onClick={() => setMode('simulation')} style={styles.menuButton}>
            🌍 ライフシミュレーション
          </button>
        </div>
      </div>
    );
  }

  if (mode === 'card-game') {
    return (
      <AuthProvider>
        <MagicSpiritGame />
      </AuthProvider>
    );
  }

  if (mode === 'simulation') {
    return <SimulationApp allCards={allCards} onBack={() => setMode('menu')} />;
  }

  return null;
}

const styles: { [key: string]: React.CSSProperties } = {
  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  menuTitle: {
    fontSize: '64px',
    fontWeight: 'bold',
    color: 'white',
    marginBottom: '10px',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
  },
  menuSubtitle: {
    fontSize: '20px',
    color: 'rgba(255, 255, 255, 0.8)',
    marginBottom: '40px',
  },
  menuButtons: {
    display: 'flex',
    gap: '30px',
  },
  menuButton: {
    padding: '20px 40px',
    fontSize: '24px',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '16px',
    background: 'white',
    color: '#667eea',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
};

export default App;
